import React from 'react';
import { Search } from 'lucide-react';
import { cn } from '@/lib/cn';

interface SearchBarProps {
    value: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    placeholder?: string;
    className?: string;
    style?: React.CSSProperties;
}

export default function SearchBar({ value, onChange, className, style }: SearchBarProps) {
    return (
        <div
            className={cn(
                "flex min-w-0 items-center max-w-sm h-[38px] rounded-md border border-gray-200 bg-white px-3 py-2 text-sm ring-offset-white focus-within:ring-2 focus-within:ring-blue-300 focus-within:ring-offset-1",
                className
            )}
            style={style}
        >
            <Search size={16} className="text-gray-500 me-2 shrink-0" />
            <input
                type="text"
                dir="auto"
                className="flex h-full w-full min-w-0 truncate bg-transparent p-0 placeholder:text-gray-400 focus:outline-none disabled:cursor-not-allowed disabled:opacity-50"
                placeholder="search"
                value={value}
                onChange={onChange}
            />
        </div>
    );
}
